import { memo } from 'react';
import ClearIcon from '@mui/icons-material/Clear';
import SquareIcon from '@mui/icons-material/Square';
import { Stack, Chip, Box } from '@mui/material';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../store';

export const LegendaTurni = memo(() => {
  const { view } = useSelector((state: RootState) => state.rotaRoot);

  return (
    <Stack
      flexDirection="unset"
      flexWrap="wrap"
      justifyContent="start"
      alignItems="start"
    >
      <Chip
        avatar={
          <SquareIcon
            sx={{
              color: 'transparent!important',
              borderRadius: '4px',
              border: '1px solid var(--highlight-color)',
              boxSizing: 'border-box',
            }}
          ></SquareIcon>
        }
        label="Orario predefinito"
        variant="outlined"
        sx={{ border: 'none' }}
      />

      <Chip
        avatar={
          <Box
            sx={{
              background: 'var(--closed-color)',
              opacity: 0.5,
              color: 'var(--color)',
              borderRadius: '4px',
              border: '1px solid var(--highlight-color)',
              boxSizing: 'border-box',
              alignContent: 'center',
              alignItems: 'center',
              textAlign: 'center',
            }}
          >
            <ClearIcon sx={{ height: '15px', width: '15px', pt: '2px' }} />
          </Box>
        }
        label="Giorno di chiusura predefinito"
        variant="outlined"
        sx={{ border: 'none' }}
      />
      <Chip
        avatar={
          <SquareIcon
            sx={{
              color: 'transparent!important',
              borderRadius: '4px',
              border: '1px solid #1375c0',
              boxSizing: 'border-box',
              background: '#1375c020',
            }}
          ></SquareIcon>
        }
        label="Orario straordinario"
        variant="outlined"
        sx={{ border: 'none' }}
      />
      <Chip
        avatar={
          <SquareIcon
            sx={{
              color: 'transparent!important',
              boxSizing: 'border-box',

              borderRadius: '4px',
              border: '1px solid var(--accent-pressed-color)',
              background: '#de5c5c30',
            }}
          />
        }
        label="Giorno di chiusura straordinario"
        variant="outlined"
        sx={{ border: 'none' }}
      />
    </Stack>
  );
});
